import React, { useState, useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as WhatsAppIcon } from "assets/icons/whatsapp.svg";
import { LocalizationContext } from "contexts/localizationContext";
import { PHONE_URL } from "constants/api"; 

export const WhatsAppAdminLink = () => {
    const { language } = useContext(LocalizationContext);
    
    const [phoneNumber, setPhoneNumber] = useState("12024401768"); 

    useEffect(() => {
        fetch(PHONE_URL, {
            method: 'GET',
            headers: {
                "Accept": "application/json",
                'Content-type': 'application/json;charset=utf-8',
                'Accept-Language': `${language}`.toLowerCase()
            },
        })
        .then((res) => {
            if (!res.ok) throw new Error("Network response was not ok");
            return res.json();
        })
        .then((data) => {
            if (data && data.data && data.data.adminPhoneNumber) {
                setPhoneNumber(data.data.adminPhoneNumber);
            } else if (data && data.adminPhoneNumber) {
                setPhoneNumber(data.adminPhoneNumber);
            }
        })
        .catch((error) => {
            console.error("Error fetching phone number:", error);
            setPhoneNumber("12024401768"); 
        });
    }, [language]);

    if (!phoneNumber) 
        return null;

    const cleanPhone = phoneNumber.replace(/\D/g, "");
    const whatsappUrl = `https://wa.me/${cleanPhone}`;

    const widgetContent = (
        <div 
            className="whatsapp-widget-container" 
            style={{ 
                position: 'fixed', 
                bottom: '50px', 
                right: '50px',   
                zIndex: 999999,  
            }}
        >
            <style>
                {`
                    @keyframes waPulse {
                        0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
                        70% { box-shadow: 0 0 0 14px rgba(37, 211, 102, 0); }
                        100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
                    }
                    .wa-pulse-btn {
                        animation: waPulse 2s infinite;
                        border-radius: 50% !important;
                    }
                    .wa-pulse-btn:hover {
                        animation: none;
                        transform: scale(1.08);
                    }
                    .wa-pulse-btn svg {
                        transition: transform 0.3s ease;
                    }
                    .wa-pulse-btn:hover svg {
                        transform: scale(1.05);
                    }
                `}
            </style>

            <a 
                href={whatsappUrl}
                target="_blank" 
                rel="noopener noreferrer"
                className="wa-pulse-btn w-14 h-14 rounded-full bg-transparent transition-all duration-300 cursor-pointer flex items-center justify-center shadow-lg"
                title="Contact us on WhatsApp"
                style={{ padding: '0' }}
            >
                <WhatsAppIcon 
                    style={{ width: '45px', height: '45px', display: 'block' }} 
                />
            </a>
        </div>
    );

    return createPortal(widgetContent, document.body);
};